import { unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/index/lightPoint.png';
import _imports_1 from '@/assets/img/index/fuzzingIcon.png';
import _imports_2 from '@/assets/img/index/checkNext.svg';
import _imports_3 from '@/assets/img/index/sastIcon.png';
const _withScopeId = n => (_pushScopeId("data-v-2caa592a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-page"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "大语言模型的能力")]), /*#__PURE__*/_createElementVNode("div", {
  class: "con-cell"
}, [/*#__PURE__*/_createElementVNode("span", null, "高级特征识别"), /*#__PURE__*/_createElementVNode("span", null, "大数据处理能力"), /*#__PURE__*/_createElementVNode("span", null, "自动化"), /*#__PURE__*/_createElementVNode("span", null, "智能化"), /*#__PURE__*/_createElementVNode("span", null, "上下文理解"), /*#__PURE__*/_createElementVNode("span", null, "自然语言处理技术"), /*#__PURE__*/_createElementVNode("span", null, "迁移学习")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "优化传统安全技术，提升安全任务的效率和准确性")]), /*#__PURE__*/_createElementVNode("div", {
  class: "con-cell"
}, [/*#__PURE__*/_createElementVNode("span", null, "静态代码扫描"), /*#__PURE__*/_createElementVNode("span", null, "模糊测试"), /*#__PURE__*/_createElementVNode("span", null, "二进制反编译")])])], -1));
const _hoisted_2 = {
  class: "back-agent"
};
const _hoisted_3 = {
  alt: ""
};
const _hoisted_4 = {
  class: "con-detail"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-back",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "无垠模糊测试智能体", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_8 = [_hoisted_5, _hoisted_6, _hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-back",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "无瑕软件缺陷分析智能体", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_12 = [_hoisted_9, _hoisted_10, _hoisted_11];
import agentCom from './agentCom.vue';
import { ref } from 'vue';
export default {
  __name: 'safeProductAgent',
  setup(__props, {
    expose: __expose
  }) {
    let pageActive = ref(false);
    const jumpPage = url => {
      // 获取当前页面地址
      url = `${url}?trackCode=${window.location.href.split('//')[1]}`;
      window.open(url);
    };
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(pageActive) ? 'safe-agent active' : 'safe-agent')
      }, [_createVNode(agentCom, {
        showBotton: false,
        title: '安全工具型智能体'
      }, {
        left: _withCtx(() => [_hoisted_1]),
        right: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [[_directive_lazy, require('@/assets/img/index/safeProductAgentInst.svg')]])])]),
        bottom: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", {
          class: "detail-cell margin-box",
          onClick: _cache[0] || (_cache[0] = $event => jumpPage('codeProduct.html'))
        }, _hoisted_8), _createElementVNode("p", {
          class: "detail-cell",
          onClick: _cache[1] || (_cache[1] = $event => jumpPage('sastProduct.html'))
        }, _hoisted_12)])]),
        _: 1
      })], 2);
    };
  }
};